import { useNode } from '@craftjs/core';
import {
  TitlePanel,
  AnswersPanel,
  LayoutPanel,
  ValidationPanel,
  LogicPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormDateInputComponent, FormDateInputProps } from 'src/features/generalForms/builder/types/DateInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppDateRangeField } from 'src/features/generalForms/uikit/fields/daterange/dateRangeField';

export const FormDateRangeInput: FormDateInputComponent = (props) => {
  const {
    connectors,
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { connect, drag } = connectors;
  const validationResult = useDataKeyValidation();

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppDateRangeField
        disabled={props.disabled}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.endDateIsOptional && props.startDateIsOptional,
          prefix: props.prefix,
        }}
        startDate={props.defaultValue?.[0] || ''}
        endDate={props.defaultValue?.[1] || ''}
        onStartChange={(e) =>
          setProp((p: FormDateInputProps) => {
            if (!e.target.value && !props.defaultValue?.[1]) {
              p.defaultValue = undefined;
              return;
            }

            p.defaultValue = [e.target.value || null, props.defaultValue?.[1]];
          }, 500)
        }
        onEndChange={(e) =>
          setProp((p: FormDateInputProps) => {
            if (!e.target.value && !props.defaultValue?.[0]) {
              p.defaultValue = undefined;
              return;
            }

            p.defaultValue = [props.defaultValue?.[0], e.target.value || null];
          }, 500)
        }
        errorText={validationResult?.message}
      />
    </div>
  );
};

export const FormDateRangeInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel sections={['DateRange']} />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormDateRangeInput.craft = {
  displayName: 'Date range',
  rules: { canDrag: () => true },
  related: { settings: FormDateRangeInputSettings },
};
